import { RemoteParticipantWrapper as BaseRemoteParticipant, RemoteParticipantWrapperProps } from '../session';
import { useHandleReceivedMessageCallback } from './messages/useHandleReceivedMessageCallback';
import { useTrackSessionParticipantViewedEvent } from './useTrackSessionParticipantViewedEvent';

export function RemoteParticipant(props: Omit<RemoteParticipantWrapperProps, 'onMessageReceived'>) {
  const handleReceivedMessage = useHandleReceivedMessageCallback();
  useTrackSessionParticipantViewedEvent(props.remoteParticipant.identity);
  return <BaseRemoteParticipant {...props} onMessageReceived={handleReceivedMessage} />;
}
